"use client";
import ElaScript from "@/components/ElaScript";
import { useQueryStorage } from "@/contexts/QueryStorageContext";

/**
 * Wrapper for ElaScript that resolves the process from URL query params
 * (via QueryStorageContext) instead of fetching it from a contract.
 * Use on pre-contract screens where no `[id]` is available yet.
 */
export default function ElaScriptFromQuery() {
  const { storedQueries } = useQueryStorage();
  return <ElaScript process={storedQueries.process?.value} />;
}
